import React, { useEffect, useState } from "react";
import isiLogo from "../../public/isi-logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../Components/Loader"; // Adjust path if needed

export default function GoldRateDisplay() {
  const navigate = useNavigate();
  const currentDate = new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const [rates, setRates] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const userStr = localStorage.getItem("user");
        if (!userStr) {
          setLoading(false);
          return;
        }
        const user = JSON.parse(userStr);
        if (!user || !user.Email) {
          setLoading(false);
          return;
        }

        const { data } = await axios.get(
          `/server/baos_function/getRates/${user.Email}`
        );
        const jewelRate = data?.data?.[0]?.Jewel_Rate;
        if (jewelRate) {
          setRates(jewelRate);
          setMessage(jewelRate.Message);
        }
      } catch (err) {
        console.error("Error fetching rates:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRates();
  }, []);

  const handleLogout = () => setShowLogoutModal(true);
  const confirmLogout = () => {
    localStorage.clear();
    navigate("/login");
  };
  const cancelLogout = () => setShowLogoutModal(false);
  const handleReload = () => window.location.reload();

  const rateLabels = [
    { label: "item1", price: "item1_Price" },
    { label: "item2", price: "item2_Price" },
    { label: "item3", price: "item3_Price" },
    { label: "item4", price: "item4_Price" },
    { label: "item5", price: "item5_Price" },
    { label: "item6", price: "item6_Price" },
    { label: "item7", price: "item7_Price" },
  ];

  if (loading) return <Loader />;

  return (
    <div className="screen-wrapper">
      <div className="gold-border">
        {/* Top Bar */}
        <div className="top-bar">
          <div className="logo-container">
            <img src={isiLogo} alt="ISI Logo" className="isi-logo" />
          </div>
          <div className="top-center">
            <div className="shop-name">{rates.Shop_Name}</div>
            <div className="date">{currentDate}</div>
          </div>
          <div className="icon-buttons">
            <button className="icon-btn" onClick={handleReload}>
              <i className="fas fa-rotate-right"></i>
            </button>
            <button className="icon-btn" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt"></i>
            </button>
          </div>
        </div>

        {/* Scroll Message */}
        <div className="scroll-container">
          <marquee
            className="scroll-text"
            behavior="scroll"
            direction="left"
            scrollamount="6"
          >
            {message}
          </marquee>
        </div>

        {/* Rate Display */}
        <div className="rate-section">
          {rateLabels.map(({ label, price }) => (
            <div className="rate-row" key={label}>
              <div className="rate-type">{rates[label]}</div>
              <div className="rate-value"> {rates[label]==="GST"?"% "+rates[price]: "" + rates[price]}</div>
              
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="footer">
          BOAS
        </div>
      </div>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>Are you sure you want to logout?</p>
            <div className="modal-buttons">
              <button className="confirm-btn" onClick={confirmLogout}>
                Yes
              </button>
              <button className="cancel-btn" onClick={cancelLogout}>
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Styles */}
      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap");

        html,
        body {
          margin: 0;
          padding: 0;
          height: 100vh;
          width: 100vw;
          background: black;
          font-family: "Inter", sans-serif;
        }

        .screen-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          width: 100vw;
          padding: 1vh;
          box-sizing: border-box;
          overflow-y: auto;
        }

        .gold-border {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          max-width: 1000px;
          max-height: 95vh;
          border: 1vw solid #facc15;
          padding: 1vh 1vw;
          background: #111;
          gap: 1vh;
          box-sizing: border-box;
        }

        .top-bar {
          height: 12%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        }

        .logo-container {
          width: 150px;
          height: 150%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .isi-logo {
          height: 160px;
          max-width: 160px;
          object-fit: contain;
          display: block;
        }

        .top-center {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }

        .shop-name {
          font-size: 2.8rem;
          font-weight: bold;
          color: #facc15;
        }

        .date {
          font-size: 1.8rem;
          color: #60a5fa;
        }

        .icon-buttons {
          display: flex;
          gap: 1rem;
        }

        .icon-btn {
          width: 60px;
          height: 60px;
          border: 3px solid #facc15;
          background: transparent;
          color: #facc15;
          border-radius: 50%;
          font-size: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.3s, transform 0.3s;
        }

        .icon-btn:hover {
          background: #facc15;
          color: black;
          transform: scale(1.1);
        }

        .scroll-container {
          height: 6%;
          overflow: hidden;
        }

        .scroll-container {
          height: 6%;
          overflow: hidden;
          display: flex;
          align-items: center;
          background-color: transparent; /* Optional, for clarity */
          padding: 0 1rem;
        }

        .scroll-text {
          font-size: 3rem;
          font-weight: bold;
          color: #facc15;
          white-space: nowrap;
        }

        .rate-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          gap: 1vh;
          overflow-y: auto;
        }

        .rate-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5vh 2vw;
          font-size: 3.8rem; /* Increased font size */
          font-family: "Inter", sans-serif;
          background-color: black;
          border: 2px solid #0f0;
          border-radius: 1rem;
          color: #00ff00;
          box-shadow: 0 0 10px #0f0;
          height: 7vh;
        }

        .rate-type {
          color: #facc15;
        }

        .footer {
          height: 3%;
          text-align: center;
          font-size: 1rem;
          color: #facc15;
          border-top: 1px solid #facc15;
          padding-top: 0.4rem;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }

        .modal-content {
          background: #222;
          padding: 2rem;
          border: 2px solid #facc15;
          border-radius: 10px;
          text-align: center;
          color: #facc15;
          box-shadow: 0 0 10px #facc15;
        }

        .modal-buttons {
          margin-top: 1rem;
          display: flex;
          gap: 1rem;
          justify-content: center;
        }

        .confirm-btn,
        .cancel-btn {
          padding: 0.8rem 1.5rem;
          font-size: 1.2rem;
          font-weight: bold;
          cursor: pointer;
          border-radius: 5px;
          border: none;
          transition: all 0.3s;
        }

        .confirm-btn {
          background: #f87171;
          color: white;
        }

        .cancel-btn {
          background: #60a5fa;
          color: white;
        }

        .confirm-btn:hover,
        .cancel-btn:hover {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
}
